import {Box, Chip, Group} from '@mantine/core';
import type { DateInputProps} from '@mantine/dates';
import {DateInput} from '@mantine/dates';
import type {DatePreset} from './datePresets';
import { resolvePresetToDate} from './datePresets';

export interface DatePickerProps extends DateInputProps {
  required?: boolean;
  label: string;
  ariaLabel?: string;
  minDate?: Date;
  maxDate?: Date;
  value: Date | null;
  error?: boolean;
  disabled?: boolean;
  description?: string;
  readonly?: boolean;
  presets?: DatePreset[];

  onDateChangeCallback: (value: Date, label: string) => void;
}
export const DatePicker: React.FC<DatePickerProps> = ({
  required,
  label,
  minDate = new Date(1901, 1, 1),
  maxDate = new Date(2999, 12, 31),
  ariaLabel,
  value,
  error,
  disabled,
  description,
  readonly,
  presets,
  onDateChangeCallback,
  ...rest
}) => {
  let val = value;
  if (val) {
    val = new Date(String(val));
  }
  return (
    <Box mb="md">
      <DateInput
        aria-label={ariaLabel}
        label={label}
        value={val}
        withAsterisk={required}
        minDate={minDate}
        maxDate={maxDate}
        valueFormat="MM/DD/YYYY"
        description={description}
        readOnly={readonly}
        clearable
        error={error && `${label} is required`}
        disabled={disabled}
        onChange={e => onDateChangeCallback(e as Date, label)}
        popoverProps={{zIndex: 1001}}
        {...rest}
      />
      {presets && (
        <Group gap="xs" mt={4}>
          {presets.map(preset => (
            <Chip
              key={preset.value}
              size="xs"
              variant="outline"
              checked={false}
              onChange={() => onDateChangeCallback(resolvePresetToDate(preset.value), label)}>
              {preset.label}
            </Chip>
          ))}
        </Group>
      )}
    </Box>
  );
};
